.inline-input {
  width: 100%;
  border-width: 1px;
  border-color: transparent;
  background-color: transparent;
  border-radius: var(--dds-border-radius-input);

  @media (prefers-reduced-motion: no-preference) {
    transition:
      background-color var(--dds-motion-micro-state),
      border-color var(--dds-motion-micro-state),
      var(--dds-focus-transition);
  }

  &:focus {
    background-color: var(--dds-color-surface-default);
  }
}

.inline-select {
  appearance: none;
  text-overflow: ellipsis;
  cursor: pointer;
}

.inline-input:hover:enabled:read-write:not(:focus),
.inline-select:hover:enabled:not(:focus) {
  border-color: transparent;
  box-shadow: none;
  background-color: var(--dds-color-surface-hover-default);
}

.inline-input--danger {
  border-color: var(--dds-color-border-danger);
  box-shadow: 0 0 0 1px var(--dds-color-border-danger);
}

.inline-textarea {
  resize: vertical;
  height: initial;
}

/* Sentrerer ikonet i forhold til første linjen med tekst */
.edit-icon-textarea {
  position: absolute;
  top: var(--dds-spacing-x0-25);
}

.clear-button {
  right: calc(var(--dds-spacing-x0-75) + var(--dds-size-icon-small));
}
